module.exports = global.mapref = {
    esriID: null
};